// import Mock from "../mock";

// const userList = [
//   {
//     id: 1,
//     role: "ADMIN",
//     name: "web damn",
//     username: "jason_alexander",
//     email: "admin@webdamn.com",
//     avatar: "/assets/images/face-6.jpg",
//     age: 25
//   },
//   {
//     id: 2,
//     role: "TEACHER",
//     name: "John Doe",
//     username: "john_doe",
//     email: "teacher@school.com",
//     avatar: "/assets/images/face-2.jpg",
//     age: 30
//   }
// ];

// // Login endpoint
// Mock.onPost("https://www.api-berhampore.dbsmerp.in/login").reply(async (config) => {
//   try {
//     const { email } = JSON.parse(config.data);
//     const user = userList.find((u) => u.email === email);

//     if (!user) return [400, { message: "Invalid email or password" }];

//     const payload = { user };
//     return [200, payload];
//   } catch (err) {
//     console.error(err);
//     return [500, { message: "Internal server error" }];
//   }
// });

// // Register endpoint (optional for teacher)
// Mock.onPost("/api/auth/register").reply((config) => {
//   try {
//     const { email, username } = JSON.parse(config.data);
//     const user = userList.find((u) => u.email === email);

//     if (user) return [400, { message: "User already exists!" }];

//     const newUser = {
//       id: userList.length + 1,
//       role: "GUEST",
//       name: "Unknown",
//       age: 25,
//       email: email,
//       username: username,
//       avatar: "/assets/images/face-6.jpg"
//     };

//     userList.push(newUser);

//     const payload = { user: { ...newUser } };
//     return [200, payload];
//   } catch (err) {
//     console.error(err);
//     return [500, { message: "Internal server error" }];
//   }
// });

// // Profile endpoint
// Mock.onGet("https://www.api-berhampore.dbsmerp.in/api/auth/profile").reply((config) => {
//   try {
//     const payload = { user: userList[0] }; // Replace with dynamic logic for authentication
//     return [200, payload];
//   } catch (err) {
//     console.error(err);
//     return [500, { message: "Internal server error" }];
//   }
// });
